import React, { Component } from 'react';
import axios from '../../axios';
import format from 'format-number'
import { connect } from 'react-redux'
import moment from 'moment'
import { resetCekKartuState } from '../../actions/formCekKartuAction'
import Alert from 'react-s-alert'
import qs from 'qs'
import queryString from 'query-string'
import Dropzone from 'react-dropzone'

import {
  Badge
} from "reactstrap";


const initialState = {    
    tugas_answer_id            : "",
    tugas_judul         : "",
    tugas_desc          : "",
    tugas_status        : "",
    tugas_create_date   : "",
    tugas_due_date      : "",
    ta_correction_file_url : "",
    tugas_file          : [],
    dataTugas           : [],
    dataAnswer          : [],
    dataAnswerFile      : [],
    isButtonLoading     : false,
    isLoading           : false,
}

class TugasAnswerDetail extends Component {
    constructor(props) {
        super(props)
        this.state = initialState
        this.handleSubmit = this.handleSubmit.bind(this);

    }            

    loadDetailData() {

       this.setState({ isLoading: true })

        const params = qs.stringify({
            locale:"id",
            platform:"web",
            tugas_answer_id:this.props.match.params.tugas_answer_id
        })
        axios({
            method: 'post',
            url: '/tugas/hasil-detail?' + params
        })
        .then((response) => {

            const result = response.data
            console.log(result)
            if (result.status === true) {                
                
                this.setState({
                    dataTugas: result.data.tugas,
                    dataAnswer: result.data.tugas_answer,
                    dataAnswerFile: result.data.tugasAnswerFile,
                    isLoading: false
                })
            }
            else {
           
                Alert.error(result.text)
                this.setState({ isLoading: false, dataTugas:[] })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }
    
    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if ([]) {
            formData.append('answer_file', this.state.tugas_file[0])
        }else{
            formData.append('answer_file', '')
        }



        formData.append('tugas_answer_id', this.props.match.params.tugas_answer_id)
        formData.append('locale', "id")
        formData.append('platform', "web")

        const url = "/tugas/hasil-koreksi"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;
                if (result.status) {
                    Alert.success(result.text)
                    this.props.history.replace("/tugasanswer/detail/"+this.state.tugas_id)
                }
                else {
                    if (Array.isArray(result.text)) {

                        result.text.map(item => {
                            Alert.error(item)
                            return true
                        })
                    }
                    else {
                        Alert.error(result.text)
                    }
                    this.setState({ isButtonLoading: false })
                }             
            }) 
            .catch(error => {
                console.log("ERROR", error)
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.tugas_file
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            tugas_file: copiedStateFiles
        })
    }

    onDrop(files) {
        const newState = this.state.tugas_file.concat(files)
        this.setState({
            tugas_file: newState
        });
    }

    componentDidMount() {
        this.loadDetailData()
    }

    
    render() {
        
        return (
            <div className="col-sm-12">                
                <div className="card">
                    <div className="card-header">
                        Informasi Tugas
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tugas Judul</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.tugas_judul}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tugas Create Date</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataTugas.tugas_create_date}</b>
                            </div>
                        </div>
                                                              
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Informasi Jawaban Siswa
                    </div>
                    <div className="card-block">
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tugas Judul</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataAnswer.user_nama}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Nis</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataAnswer.siswa_nis}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Kelas</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataAnswer.kelas_nama}</b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tanggal</label>
                            <div className="col-md-10">
                                {": "}<b>{this.state.dataAnswer.ta_create_date}</b>
                            </div>
                        </div>
                        {/*<div className="form-group row">*/}
                        {/*    <label className="col-md-2 form-control-label">File</label>*/}
                        {/*    <div className="col-md-10">*/}
                        {/*        {": "}*/}
                        {/*        <b>*/}
                        {/*            <a href={this.state.dataAnswer.ta_file_url} target="_blank" rel="noopener noreferrer">Download</a>*/}
                        {/*        </b>*/}
                        {/*    </div>*/}
                        {/*</div>  */}
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">File Koreksi</label>
                            <div className="col-md-10">
                                {": "}
                                <b>
                                    {this.state.dataAnswer.ta_correction_file_url == null ? "Tidak ada data" : <a href={this.state.dataAnswer.ta_correction_file_url} target="_blank" rel="noopener noreferrer">Download</a>}
                                </b>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">File Answer Link</label>
                            <div className="col-md-10">
                                {": "}
                                    <span className="alert alert-danger" role="alert">
                                    {
                                        this.state.dataAnswer.ta_url ? (
                                            <a target="_blank" href={this.state.dataAnswer.ta_url}>{this.state.dataAnswer.ta_url}</a>
                                        ): "Link tidak ditemukan."
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Answer Files
                    </div>
                    <div className="card-block">
                        <div className="card-block">
                            {
                                this.state.dataAnswerFile.length > 0 ||  this.state.dataAnswer ? (
                                    <div>
                                        <table className="table table-bordered">
                                            <thead>
                                            <tr>
                                                <th width="25">No</th>
                                                <th>Nama File</th>
                                                <th>Format</th>
                                                <th>Tanggal Upload</th>
                                                <th>Download</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                this.state.dataAnswer.ta_file_name ? (
                                                    <tr key="">
                                                        <td>
                                                            1
                                                        </td>
                                                        <td>
                                                            {this.state.dataAnswer.ta_file_name}
                                                        </td>
                                                        <td>
                                                            -
                                                        </td>
                                                        <td>
                                                            -
                                                        </td>
                                                        <td>
                                                            <a href={this.state.dataAnswer.ta_file_url} target="_blank" rel="noopener noreferrer"><i className="fa fa-download"></i> Download</a>
                                                        </td>
                                                    </tr>
                                                ): ""
                                            }

                                            {
                                                this.state.dataAnswerFile.length > 0 || this.state.dataAnswer ? (
                                                    this.state.dataAnswerFile.map((item, i) => (
                                                        <tr key={"files" + i}>
                                                            <td>
                                                                {i + this.state.dataAnswer.ta_file_name ? i+2 : 1}
                                                            </td>
                                                            <td>
                                                                {item.ta_file_nama}
                                                            </td>
                                                            <td>
                                                                {item.ta_file_ext}
                                                            </td>
                                                            <td>
                                                                {item.ta_file_create_date}
                                                            </td>
                                                            <td>
                                                                <a href={item.ta_file_url} target="_blank" rel="noopener noreferrer"><i className="fa fa-download"></i> Download</a>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ): (
                                                    <tr key="">
                                                        <td colSpan={4}>
                                                            No Files
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                ):(
                                    <div className="alert alert-danger" role="alert">
                                        Anda belum mengirim jawaban!
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                {/*<div className="card">*/}
                {/*    <div className="card-header">*/}
                {/*        Informasi Koreksi*/}
                {/*    </div>*/}
                {/*    <div className="card-block">*/}
                {/*        <div className="form-group row">*/}
                {/*            <label className="col-md-2 form-control-label">NIlai</label>*/}
                {/*            <div className="col-md-10">*/}
                {/*                <input */}
                {/*                    name="nilai"*/}
                {/*                    type="number"*/}
                {/*                    className="form-control"*/}
                {/*                    placeholder="Nilai" */}
                {/*                    onChange={this.handleChange} */}
                {/*                    value={this.state.nilai} />*/}
                {/*            </div>*/}
                {/*        </div>                                       */}
                {/*        <div className="form-group row">*/}
                {/*            <label className="col-md-2 form-control-label">{this.props.mode === "Edit" && "Ganti"} File Koreksi</label>*/}
                {/*            <div className="col-md-10">*/}

                {/*                <Dropzone*/}
                {/*                    onDrop={this.onDrop.bind(this)}*/}
                {/*                    style={{*/}
                {/*                        width: "100%",*/}
                {/*                        height: "auto",*/}
                {/*                        border: "2px dashed #e9e9e9",*/}
                {/*                        padding: "20px 30px",*/}
                {/*                        color: "#888",*/}
                {/*                        cursor: "pointer",*/}
                {/*                        textAlign: "center",*/}
                {/*                        marginBottom: "15px"*/}
                {/*                    }}*/}
                {/*                >*/}
                {/*                    Klik atau drop file disini untuk mengupload file*/}
                {/*                </Dropzone>*/}
                {/*                <ul>*/}
                {/*                    {*/}
                {/*                        this.state.tugas_file.map((item, index) =>*/}
                {/*                            <li key={"file" + index} style={{ marginBottom: "10px" }}>*/}
                {/*                                {item.name} {" "}*/}
                {/*                                <button*/}
                {/*                                    title="Hapus"*/}
                {/*                                    className="btn btn-sm btn-danger"*/}
                {/*                                    onClick={() => this.handleDeleteFile(index)}*/}
                {/*                                    type="button"*/}
                {/*                                >*/}
                {/*                                    <i className="fa fa-remove"></i>*/}
                {/*                                </button>*/}
                {/*                            </li>*/}
                {/*                        )*/}
                {/*                    }*/}
                {/*                </ul>*/}
                {/*            </div>*/}
                {/*        </div> */}
                {/*    </div>*/}
                {/*    <div className="card-footer">*/}
                {/*        <button */}
                {/*            type="button" */}
                {/*            className="btn btn-md btn-primary"*/}
                {/*            disabled={this.state.isButtonLoading && "disabled"}*/}
                {/*            onClick={this.handleSubmit}*/}
                {/*        >*/}
                {/*            {this.state.isButtonLoading ? "Loading" : "Simpan"}*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        );
    }
}

export default TugasAnswerDetail;


// WEBPACK FOOTER //
// ./src/views/Tugas/TugasAnswerDetail.js